<template lang="pug">
div(
    :class="[backgroundColor, { 'relative z-[61]': $storyblok.isEditing }]"
)
    template(v-for="section in sections")
        Widget(
            :key="section._uid"
            :data="section"
        )

</template>

<script>
import { generateBackgroundColorClass } from './helpers'
import Widget from './_components/widget'

export default {
    name: 'Storyblok',
    components: {
        Widget,
    },
    provide() {
        return { $story: { shouldLazyLoad: this.shouldLazyLoad } }
    },
    props: {
        story: {
            type: Object,
            default() {
                return null
            },
        },
        forceLazyLoad: {
            type: Boolean,
            default: false,
        },
        sectionKey: {
            type: String,
            default: 'sections',
        },
    },
    data() {
        return {
            imageCount: 0,
            lazyLoadThreshold: 5,
        }
    },
    computed: {
        sections() {
            return this.story?.content?.[this.sectionKey] || []
        },
        backgroundColor() {
            return generateBackgroundColorClass(this.story?.content?.backgroundColor)
        },
    },
    watch: {
        $device: {
            handler() {
                clearTimeout(this.deviceTimeout)
                this.deviceTimeout = setTimeout(() => {
                    this.$storyblok.fetchAlgoliaData(this.story, this.sectionKey)
                }, 500)
            },
            deep: true,
        },
        story(newVal) {
            // This watcher is only for Edit Mode
            if (!this.$storyblok.isEditing) return
            clearTimeout(this.storyTimeout)
            this.storyTimeout = setTimeout(() => {
                this.$storyblok.fetchAlgoliaData(newVal, this.sectionKey)
            }, 1000)
        },
    },
    methods: {
        shouldLazyLoad(forceImage) {
            if (this.$storyblok.isPreview) return false
            if (this.forceLazyLoad || forceImage) return true

            const index = this.imageCount

            this.imageCount++

            return index >= this.lazyLoadThreshold
        },
    },
}
</script>
